import "./periodicityoption.scss";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Rectangle from "../Rectangle/rectangle";

const PeriodicityOption = (props) => {
  const { periodicity, price, selected, value, onClick, saveText } = props;

  return (
    <div key={`periodicity_key_${periodicity}`} onClick={() => onClick(value)} className={`periodicity-container ${selected ? `active` : ``}`}>
      <div className="periodicity-pay-text">
        <span>Pay {periodicity}</span>
        {selected && <FontAwesomeIcon style={{ color: "#0084FF", fontSize: "18px" }} icon={faCheck} />}
      </div>
      <div className="periodicity-pay-text">
        <span>${price}/month</span>
        {saveText && <Rectangle title={saveText} className="periodicity-save" />}
      </div>
    </div>
  );
};
export default PeriodicityOption;